module.exports = __webpack_public_path__ + "media/application/images/svgs/log-out-4d0f32ee2c5e3a7f0957a4d115232d4c.svg";